import { render, staticRenderFns } from "./TakingAdd.vue?vue&type=template&id=2fac53ec"
import script from "./TakingAdd.vue?vue&type=script&lang=js"
export * from "./TakingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports